// src/services/codigoOrdenService.ts
import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'codigos-orden/';

// Interfaz para CodigoOrdenConfig
export interface CodigoOrdenConfig {
  id: number;
  nombre: string;
  prefijo: string;
  activo: boolean;
  fecha_creacion: string;
}

// Obtener todos los prefijos
export const fetchCodigoOrdenConfigs = async (): Promise<CodigoOrdenConfig[]> => {
  return handleRequestWithAuth(async () => {
    const response = await axiosInstance.get(API_URL);
    return response.data;
  });
};

// Crear un nuevo prefijo de orden
export const createCodigoOrdenConfig = async (data: {
  nombre: string;
  prefijo: string;
  activo: boolean;
}): Promise<CodigoOrdenConfig> => {
  return handleRequestWithAuth(async () => {
    const response = await axiosInstance.post(API_URL, data);
    return response.data;
  });
};

// Actualizar un prefijo existente
export const updateCodigoOrdenConfig = async (
  id: number,
  data: {
    nombre: string;
    prefijo: string;
    activo: boolean;
  }
): Promise<CodigoOrdenConfig> => {
  return handleRequestWithAuth(async () => {
    const response = await axiosInstance.put(`${API_URL}${id}/`, data);
    return response.data;
  });
};

// Eliminar un prefijo
export const deleteCodigoOrdenConfig = async (id: number): Promise<void> => {
  return handleRequestWithAuth(async () => {
    await axiosInstance.delete(`${API_URL}${id}/`);
  });
};
